import { UserAccountPopover } from "./Components/UserAccountPopover";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import { useAppPopovers } from "../../app/state/popoverSlice/hook/use-app-popovers";
import { useAccountMenu } from "./hooks/use-account-menu";
import { StaticTokenModal } from "./Components/StaticTokenModal";
import { HeaderServiceManager } from "./Components/HeaderServiceManager";
import { AddUserModal } from "./Components/AddUserModal";
import { HeaderNavigation } from "./Components/HeaderNavigation";
import { HeaderActions } from "./Components/HeaderActions";
import styles from "./styles.module.css";

export const AppHeader = () => {
  const { handleCloseModal } = useAppModals();
  const { handleClosePopover, handleOpenPopover } = useAppPopovers();
  const { handlePopoverActions } = useAccountMenu();

  return (
    <header className={styles.header}>
      <HeaderNavigation openPopover={handleOpenPopover} />
      <HeaderActions openPopover={handleOpenPopover} />
      <UserAccountPopover
        popoverActions={handlePopoverActions}
        closePopover={handleClosePopover}
      />
      <StaticTokenModal closeModal={handleCloseModal} />
      <HeaderServiceManager closePopover={handleClosePopover} />
      <AddUserModal closeModal={handleCloseModal} />
    </header>
  );
};
